// TODO: 중복제거

import { renderDataTypeWithComma } from '@/lib/utils/renderType'
import { BooksProduct, isBooksProduct } from 'src/api/booksProducts'
import {
	CurriculumsWithString,
	GradesWithString,
	HandoutDTO,
	IProduct,
	Subjects,
	SubjectsWithString,
} from 'src/api/product'

interface IcoreInfo {
	type: string
	value: number | string | null
	link?: string
}

// TODO: remove publisherName parameter
//수업자료
export default function coreInfoList(
	product: IProduct | BooksProduct,
	publisherName: string,
): IcoreInfo[] {
	if (isBooksProduct(product)) {
		return [
			{
				type: '과목',
				value: SubjectsWithString[product.subject],
			},
			{
				type: '출판사',
				value: publisherName,
			},
			{
				type: '학년',
				value:
					CurriculumsWithString[product.curriculum] +
					product.grades.map((grade) => GradesWithString[grade]).join(', '),
			},
		]
	}

	const {
		subject,
		curriculum,
		grade,
		based_textbook_title,
		genre,
		era,
		question_number,
		unit,
		publisher,
	} = product.source as HandoutDTO // TODO: remove type assertion

	const subjectValue = SubjectsWithString[subject]
	const gradeValue = CurriculumsWithString[curriculum] + GradesWithString[grade]
	// TODO: remove type assertion
	const dataTypeValue = renderDataTypeWithComma((product.source as HandoutDTO).data_type)

	switch (product.source_type) {
		case 'handout':
			if (subject === Subjects.KO) {
				return [
					{
						type: '과목',
						value: subjectValue,
					},
					{
						type: '출처작품',
						value: based_textbook_title,
					},
					{
						type: '장르',
						value: genre,
					},
					{
						type: '시대',
						value: era,
					},
					{
						type: '문항 수',
						value: question_number,
					},
					{
						type: '학년',
						value: gradeValue,
					},
				]
			}
			return [
				{
					type: '과목',
					value: subjectValue,
				},
				{
					type: '출처교재',
					value: based_textbook_title,
					link: `/products/${product?.source?.product_id}`,
				},
				{
					type: '단원',
					value: unit,
				},
				{
					type: '자료유형',
					value: dataTypeValue,
				},
				{
					type: '문항 수',
					value: question_number,
				},
				{
					type: '학년',
					value: gradeValue,
				},
			]
		case 'textbook':
		case 'workbook':
			return [
				{
					type: '과목',
					value: subjectValue,
				},
				{
					type: '출판사',
					value: publisherName,
				},
				{
					type: '학년',
					value: gradeValue,
				},
			]
		case 'work':
			return [
				{
					type: '과목',
					value: subjectValue,
				},
				{
					type: '저작권자',
					value: publisher,
				},
				{
					type: '장르',
					value: genre,
				},
				{
					type: '시대',
					value: era,
				},
			]
	}
}
